<template>
  <div>
    <div class="contents">
      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">
              {{ $t("title.admin.timezonename") }}
            </th>
            <th class="col-auto">{{ $t("title.admin.timezoneoffset") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.state") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="totalCnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto">
                <a class="more text-break" @click="goView(index)">
                  {{ item.timezone_name }}
                </a>
              </td>
              <td class="col-auto">
                (UTC
                {{
                  item.timezone_offset >= 0
                    ? "+" + item.timezone_offset
                    : item.timezone_offset
                }}:00)
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.state }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="5">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.number") }}</div>
                    <div class="col-7">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.state") }}</div>
                    <div class="col-7">{{ item.state }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-7 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="
            items.length == 0
              ? $router.push({ name: 'TimezoneWrite' })
              : no_can_register()
          "
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "TimezoneList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$store.state.searchData.startdate ||
          1,
        enddate:
          this.$route.query.enddate ||
          this.$store.state.searchData.enddate ||
          1,
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getTimezoneList();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getTimezoneList();
    },

    "searchData.pageno": function () {
      this.getTimezoneList();
    },
  },

  created() {
    this.getTimezoneList();
  },
  methods: {
    getTimezoneList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getTimezoneList(this.searchData, (flag, data) => {
        if (flag) {
          this.totalCnt = data.listcnt;
          this.pageTotal = Math.ceil(data.listcnt / this.rows);
          this.items = data.list;
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          alert(data);
        }
      });
    },
    goView(idx) {
      let timezone_pk = this.items[idx].timezone_pk;
      this.$router.push({
        name: "TimezoneEdit",
        params: { timezone_pk: timezone_pk },
      });
    },
    no_can_register() {
      alert(this.$i18n.t("text.admin.no_can_register"));
    },
    linkGen(pageNum) {
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
